import { render, staticRenderFns } from "./incentive-by-amount-product-list.vue?vue&type=template&id=00c96c3c&scoped=true"
import script from "./incentive-by-amount-product-list.vue?vue&type=script&lang=js"
export * from "./incentive-by-amount-product-list.vue?vue&type=script&lang=js"
import style0 from "./incentive-by-amount-product-list.vue?vue&type=style&index=0&id=00c96c3c&prod&scoped=true&lang=css"
import style1 from "./incentive-by-amount-product-list.vue?vue&type=style&index=1&id=00c96c3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c96c3c",
  null
  
)

export default component.exports